import type { ReactNode } from 'react';
import Text from '@/components/UI/Text';
import Box from '@/components/Unistyles/Box';

export default function Section({
  children,
  testID,
  flexGrow,
}: {
  children: ReactNode;
  testID?: string;
  flexGrow?: number;
}) {
  return (
    <Box direction="vertical" space="md" testID={testID} flexGrow={flexGrow}>
      {children}
    </Box>
  );
}

export function SectionHeading({
  title,
  children,
  actions,
  actionPlacement = 'end',
}: {
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
  actionPlacement?: 'inline' | 'end';
}) {
  return (
    <Box
      direction="horizontal"
      align="center"
      justify={actionPlacement === 'inline' ? 'flex-start' : 'space-between'}
      space="md"
      wrap
    >
      <Box
        flexGrow={actionPlacement === 'inline' ? 0 : 1}
        flexShrink={1}
        minWidth={0}
        space="xs"
      >
        <Text bold size="2xl" role="heading">
          {title}
        </Text>
        {children}
      </Box>
      {actions}
    </Box>
  );
}
